@let member = staffMember(); @if (member) {
<div class="staff-tile">
  <div class="staff-tile-image-container">
    @if (member.image) {
    <img class="staff-tile-image" [src]="member.image | imageVariant" />
    } @else {
    <app-icon name="player-outline" class="staff-tile-image-placeholder"></app-icon>
    }
  </div>
  <div class="staff-tile-info">
    <div class="staff-tile-name">
      <div class="staff-tile-first-name">{{ member.first_name }}</div>
      <div class="staff-tile-surname">{{ member.last_name }}</div>
    </div>
    @if (member.staff_role) {
    <div class="staff-tile-role">{{ member.staff_role.name }}</div>
    }
  </div>
</div>
} @else {
<div class="staff-tile staff-tile-skeleton">
  <div class="staff-tile-image-container"></div>
  <div class="staff-tile-info">
    <div class="staff-tile-name">
      <div class="staff-tile-first-name"></div>
      <div class="staff-tile-surname"></div>
    </div>
    <div class="staff-tile-role"></div>
  </div>
</div>
}
